// src/app/views/standby-screen/ComingSoonCountdown.tsx

import React from 'react';
import styles from './ComingSoonCountdown.module.scss';

const ComingSoonCountdown: React.FC = () => {
  return (
    <div className={styles['coming-soon__container']}>
      <div className={styles['coming-soon__text']}>COMING SOON</div>
    </div>
  );
};

export default ComingSoonCountdown;
